// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";

import PointieBox from "../../../components/PointieBox";

import DefaultCounterCard from "../../../components/Cards/CounterCards/DefaultCounterCard";

function Counters() {
  const { t } = useTranslation("home");

  return (
    <PointieBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={6}>
            <DefaultCounterCard
              count={Number(t("counters.sitesCount"))}
              suffix={t("counters.sitesSuffix")}
              title={t("counters.sitesTitle")}
              description={t("counters.sitesDescription")}
            />
          </Grid>
          <Grid item xs={12} md={6} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={Number(t("counters.providersCount"))}
              title={t("counters.providersTitle")}
              description={
                <span dangerouslySetInnerHTML={{ __html: t("counters.providersDescription") }} />
              }
            />
          </Grid>
        </Grid>
      </Container>
    </PointieBox>
  );
}

export default Counters;
